import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  useMediaQuery,
  Button,
} from "@chakra-ui/react";
import { pana, universe } from "../../../../assets/exports";
import Diverse from "../Comps/Diverse";

const EleventhLayer = () => {
  const [isMobile] = useMediaQuery("(max-width: 501px)");

  return (
    <>
      <Flex
        flexDir="column"
        alignItems="center"
        minH="100vh"
        pl={["0", "55px", "55px", "10px"]}
        pr={["0", "55px", "55px", "10px"]}
        mb={{ base: "30px", md: "63px" }}
      >
        <Flex flexDir={{ base: "column", md: "row" }} gap="2rem">
          <Box flex={1}>
            <Heading fontSize={["24px", "24px", "30px", "40px"]}>
              Social Impact
            </Heading>
            <Text pt="24px" color="#222425" fontSize={["14px", "16px", "20px"]}>
              Experience the future of financial technology with{" "}
              <span style={{ fontWeight: "bold" }}>Fastamoni</span>. Our
              innovative platform simplifies payments, enhances access to
              quality education in Africa, and commits to sustainability. By
              utilizing e-invoices and digital receipts, we aim to reduce paper
              usage by up to 80%, contributing to SDG Goal 13: Climate Action.
              Join us in revolutionizing financial management and promoting a
              low-carbon future.
            </Text>
            <Button
              mt="60px"
              mb="52px"
              w="242px"
              h="60px"
              py="12px"
              px="10px"
              fontWeight={500}
            >
              Learn More
            </Button>
          </Box>
          <Flex justifyContent={{ base: "center", md: "flex-end" }} flex={1}>
            <Image src={universe} />
          </Flex>
        </Flex>
        <Flex
          pt={{ base: "83px", md: "124px" }}
          flexDir={{ base: "column", md: "row-reverse" }}
          gap="3rem"
        >
          <Flex flexDir="column" justifyContent="flex-end" flex={1}>
            <Heading fontSize={["24px", "24px", "30px", "40px"]}>
              Dedication To Gender Equality in the Workplace
            </Heading>
            <Text pt="24px" color="#222425" fontSize={["14px", "16px", "20px"]}>
              At <span style={{ fontWeight: "bold" }}>Fastamoni</span>, we are
              committed to promoting gender equality and empowering all
              employees to reach their full potential. We strive to create a
              supportive and inclusive workplace where everyone has equal
              opportunities to succeed, irrespective of gender. By championing
              diversity and equity, we drive innovation and foster a culture of
              respect and collaboration.
            </Text>
            <Button
              mt="60px"
              mb="52px"
              w="fit-content"
              h="60px"
              py="12px"
              fontWeight={500}
            >
              Explore Opportunities with us
            </Button>
          </Flex>
          <Flex justifyContent="flex-start" flex={1}>
            <Image objectFit="contain" src={pana} />
          </Flex>
        </Flex>
        <Diverse />
      </Flex>
    </>
  );
};
export default EleventhLayer;
